import React from "react";
import { JcUtils } from "../../utils/JcUtils";
import { JcBoxProps, JcColumn } from "../JcBox";

export interface JcPageProps extends Omit<JcBoxProps, "flexGrow"> { }

export const JcPage = (props: JcPageProps): React.ReactElement => {
    const boxProps = JcUtils.otherProps(props);
    const commonProps = JcUtils.commonProps(props, ["jc-page"]);
    return <JcColumn {...commonProps} {...boxProps} flexGrow />
}